import { component } from 'picoapp';
import Ready from '../../js/utils/ready';

export default component((node, ctx) => {
  const children = node.querySelectorAll('.appear');

  /**
   * Functions
   */
  const init = () => {
    const update = (rect) => {
      const inView = rect.top <= window.innerHeight * 0.75;

      if (inView) {
        children.forEach((child, index) => {
          setTimeout(() => {
            child.classList.add('appear--settled');
          }, index * 300);
        });
      }
    };

    Ready(() => {
      update(node.getBoundingClientRect());

      ctx.on('window:scroll', () => {
        update(node.getBoundingClientRect());
      });
    });
  };

  /**
   * Init
   */
  init();
});
